import {APP_ID, APP_KEY, SERVER_URL} from "@/configuration/AppConfigurations";
import Parse from 'parse/dist/parse.min.js';
import {patchParseFileURLs} from "@/lib/store/ParseFileURLs";
export const initParse = () =>{
	// Parse configuration & initilization
	Parse.initialize(APP_ID, APP_KEY);
	Parse.serverURL = SERVER_URL
	patchParseFileURLs()
}
